/** Registers the app shell service worker so the app meets PWA install criteria. */
export function registerServiceWorker(): void {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }
  window.addEventListener("load", () => {
    const path = `${process.env.PUBLIC_URL ?? ""}/sw.js`;
    navigator.serviceWorker.register(path).catch(() => {
      /* non-HTTPS or blocked — install prompt may still not appear */
    });
  });
}

/**
 * Removes any service worker + caches left over from when registration was enabled.
 * Mobile browsers keep a previously-registered service worker active indefinitely —
 * disabling registerServiceWorker() only stops new registrations, it doesn't undo old ones.
 * Safe to call even if no service worker was ever registered.
 */
export function unregisterServiceWorker(): void {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    })
    .catch(() => {
      /* nothing registered, or access blocked — nothing to clean up */
    });

  if ("caches" in window) {
    caches
      .keys()
      .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
      .catch(() => {
        /* cache storage unavailable — nothing to clean up */
      });
  }
}
